import React, {useState, useEffect, useRef  } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import style from './Carousel.module.scss';
import useWindowResize from '../hook/UseWindowResize';
import { useTranslation } from 'react-i18next';

const leftTransition = 'left 0.3s ease-in-out';
const leftNoTransition = 'left 0.3s ease-in-out';

const Carousel = (props) => {

  let {
    items = [],
  } = props;

  const carouselEl = useRef(null);
  const carouselSliderEl = useRef(null);

  let [carouselHeight, setCarouselHeight] = useState(0);
  let [itemWidth, setItemWidth] = useState(0);
  let [page, setPage] = useState(0);
  let [pageCount, setPageCount] = useState(items.length);
  let [transition, setTransition] = useState(leftNoTransition);
  const { t } = useTranslation();

  const updateWidth = () => {
    setTransition(leftNoTransition);
    const width = carouselEl.current.clientWidth;
    const height = carouselSliderEl.current.clientHeight;
    if (width) {
      setItemWidth(width);
    }
    if (height) setCarouselHeight(height);
  };

  useWindowResize(updateWidth);

  const onClickPrev = () => {
    if (page > 0) {
      setTransition(leftTransition);
      let newPage = page - 1;
      setPage(newPage);
    }
  };

  const onClickNext = () => {
    if (page+1 < pageCount) {
      setTransition(leftTransition);
      let newPage = page + 1;
      setPage(newPage);
    }
  };

  const hasPrev = () => {
    return pageCount>0 && page > 0;
  };

  const hasNext = () => {
    return pageCount>0 && (page+1) < pageCount;
  };

  useEffect(() => {
    updateWidth();
    setPageCount(items.length)
  }, [items]);

  let images = items.map((item, index) => {
    return (
      <div key={index} className={style.CarouselItem} style={{width: itemWidth}} >
        <div className={style.imageWrapper}>
          <img className={style.image}
               src={item.imageUrl}
               onLoad={updateWidth}
          />
        </div>
      </div>
    )
  });

  return (
    <div ref={carouselEl} className={style.Carousel} style={{height: carouselHeight}}>
      <div><i className={clsx('fa', 'fa-angle-left', style.CarouselButtonLeft, {[style.CarouselButtonDisabled]: !hasPrev()})}
              aria-hidden="true" onClick={onClickPrev}></i></div>
      <div><i className={clsx('fa', 'fa-angle-right', style.CarouselButtonRight, {[style.CarouselButtonDisabled]: !hasNext()})}
              aria-hidden="true" onClick={onClickNext}></i></div>
      <div className={style.CarouselPage}>{page+1}/{pageCount}</div>
      <div ref={carouselSliderEl}
           className={style.CarouselSlider}
           style={{zIndex:-1, transition:transition, width: itemWidth*pageCount, left: (0 - (page * itemWidth))}} >
        {images}
      </div>
    </div>
  );

};

Carousel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    imageUrl: PropTypes.string,
  })),
};

export default Carousel;
